/**
 * Find Similar Piece — return URL + scroll restoration.
 * Key is separate from oblist_collection_return.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'oblist_similar_return';
  var TTL_MS = 86400000; // 24h

  function normalizePath(href) {
    try {
      var u = new URL(href, window.location.origin);
      return u.pathname + u.search;
    } catch (e) {
      return href;
    }
  }

  function read() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || typeof data.ts !== 'number') return null;
      if (Date.now() - data.ts > TTL_MS) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function write(data) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      /* quota */
    }
  }

  function clear() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function save() {
    write({
      returnUrl: window.location.href,
      scrollY: window.scrollY || window.pageYOffset || 0,
      pendingRestore: false,
      ts: Date.now(),
    });
  }

  function markPendingRestore() {
    var data = read();
    if (!data) return;
    data.pendingRestore = true;
    data.ts = Date.now();
    write(data);
  }

  function referrerMatchesReturn(returnUrl) {
    if (!document.referrer || !returnUrl) return false;
    try {
      var ref = new URL(document.referrer);
      if (ref.origin !== window.location.origin) return false;
      return normalizePath(document.referrer) === normalizePath(returnUrl);
    } catch (e) {
      return false;
    }
  }

  function goBack() {
    var data = read();
    var returnUrl = (data && data.returnUrl) || document.referrer || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');

    if (data && referrerMatchesReturn(data.returnUrl) && window.history.length > 1) {
      // Prefer history.back so collection restore (back_forward) still works
      window.history.back();
      return;
    }

    markPendingRestore();
    window.location.assign(returnUrl);
  }

  function restoreIfPending() {
    var data = read();
    if (!data || !data.pendingRestore) return;
    if (normalizePath(data.returnUrl) !== normalizePath(window.location.href)) return;

    var pos = typeof data.scrollY === 'number' ? data.scrollY : 0;
    clear();

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    var applyScroll = function () {
      var maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      window.scrollTo(0, Math.min(pos, maxScroll));
    };

    applyScroll();
    requestAnimationFrame(applyScroll);
    setTimeout(applyScroll, 300);
    setTimeout(applyScroll, 800);
  }

  window.OblistSimilarReturn = {
    save: save,
    goBack: goBack,
    restoreIfPending: restoreIfPending,
    read: read,
    clear: clear,
  };

  // Liquid + Algolia cards: save return context before navigating to /pages/similar
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest
      ? event.target.closest('a.product-card__find-similar')
      : null;
    if (!link) return;
    event.preventDefault();
    event.stopPropagation();
    save();
    window.location.href = link.href;
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreIfPending);
  } else {
    restoreIfPending();
  }
})();
